import { render, staticRenderFns } from "./Selectbox.vue?vue&type=template&id=8b23683e&scoped=true&"
import script from "./Selectbox.vue?vue&type=script&lang=js&"
export * from "./Selectbox.vue?vue&type=script&lang=js&"
import style0 from "./Selectbox.vue?vue&type=style&index=0&id=8b23683e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b23683e",
  null
  
)

export default component.exports